import { useQuery } from '@apollo/client';

import { CompaniesSegmentsDocument } from '../../graphql/queries/companies-segments.gql-types';

type useCompaniesSegmentsProps = {
  industryId?: string;
  skip: boolean;
};
export const useCompaniesSegments = ({
  industryId = '',
  skip = false,
}: useCompaniesSegmentsProps) => {
  const response = useQuery(CompaniesSegmentsDocument, {
    variables: {
      industryId,
    },
    skip,
  });

  return response;
};
